import { useEffect } from "react";
import MoneyOverview from "./MoneyOverview";

export default function MoneyOverviewPage() {
  useEffect(() => {
    const scroller = document.querySelector(".hm-main");
    if (scroller) scroller.scrollTo({ top: 0, left: 0 });
    window.scrollTo({ top: 0, left: 0 });
  }, []);
  const openAsk = () =>
    window.dispatchEvent(
      new CustomEvent("hm_open_ask", {
        detail: {
          context: {
            module: "budget",
            module_label: "Household Budget",
            surface: "Household Budget",
          },
        },
      }),
    );

  return (
    <main className="hm-money-page">
      <section className="hm-money-page-hero">
        <div>
          <span>Household Budget</span>
          <h1>See where your household money goes</h1>
          <p>
            One clear view of confirmed spending, recurring commitments, and
            the plans ahead.
          </p>
        </div>
      </section>
      <MoneyOverview standalone />
      <div
        className="fd-food-askbar hm-money-askbar"
        aria-label="Ask HouseMind about household money"
      >
        <input
          className="fd-food-askbar__input"
          readOnly
          placeholder="✦ Ask about household money…"
          onFocus={openAsk}
        />
        <button
          className="fd-food-askbar__button"
          type="button"
          onClick={openAsk}
        >
          ✦ Ask
        </button>
      </div>
    </main>
  );
}
